import {
  GET_SYSTEM_USER_LIST_REQUEST,
  GET_SYSTEM_USER_LIST_SUCCESS,
  GET_SYSTEM_USER_LIST_FAILURE,
} from '../../../redux/types/user';

const initialState = {
  loading: false,
  users: [],
  error: null,
  success: false,
};

const getSystemUserListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SYSTEM_USER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case GET_SYSTEM_USER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload.users,
        success: true,
      };

    case GET_SYSTEM_USER_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    default:
      return state;
  }
};

export default getSystemUserListReducer;
